import * as Yup from "yup";
import moment from "moment";

export interface IMeterDeliveryRequestFormSchema {
  contractInfo: {
    contractNumber: string;
    contractTitle: string;
    proposedStartDate: string;
    estimatedProductionCompletionDate: string;
    testAtOwnFacility: boolean;
  };
  metersInfo: {
    testSets: {
      meterBrand: any
      meterModel: any
      meterPhase: "1 Phase" | "3 Phase"
      quantity: number
      content: {
        stsNumber: string
        meterNumber: string
      }[]
    }[]
    singlePhaseMeterEnclosures: number
    threePhaseMeterEnclosures: number
  };
}

export const ContractInfoFormSchema = Yup.object().shape({
  contractNumber: Yup.string().required("Contract Number is Required"),
  contractTitle: Yup.string().required("Contract Title is Required"),
  proposedStartDate: Yup.string().required("Start Date is Required").test({
    message: "Enter a valid date",
    test: (val, ctx) => {
      if(!val) return false
      return moment(val).isSameOrAfter(moment().startOf("day"));
    }
  }),
  estimatedProductionCompletionDate: Yup.string().required("Production Completion Date is Required").test({
    message: "Enter a valid date",
    test: (val, ctx) => {
      if(!val) return false
      return moment(val).isSameOrAfter(moment(ctx.parent.proposedStartDate).endOf("day"));
    }
  }),
  testAtOwnFacility: Yup.boolean().required("Required")
});

export const MetersInfoFormSchema = Yup.object().shape({
  singlePhaseMeterEnclosures: Yup.number().required("Required").min(0),
  threePhaseMeterEnclosures: Yup.number().required("Required").min(0),
  testSets: Yup.array()
    .of(
      Yup.object({
        meterBrand: Yup.object({}).required("Meter Brand is Required"),
        meterModel: Yup.object({}).required("Meter Model is Required"),
        meterPhase: Yup.string().oneOf(["1 Phase", "3 Phase"]).required("Meter Phase is Required"),
        content: Yup.array()
          .of(
            Yup.object().shape({
              stsNumber: Yup.string().required("Required").typeError("Required"),
              meterNumber: Yup.string().required("Required").typeError("Required"),
            })
          )
          .min(1, "Should contain at least a record"),
      })
    ).min(1, "Should contain at least a record"),
});

export const MeterDeliveryRequestFormSchema = Yup.object().shape({
  contractInfo: ContractInfoFormSchema.required(),
  metersInfo: MetersInfoFormSchema.required(),
});
